import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

const name = 'CacheHydration';

interface Props {
    open: boolean;
}

const CacheHydration: React.FC<Props> = ({ open }) => {
    return (< Backdrop
        sx={{ color: '#fff', backgroundColor: "rgb(0 0 0 / 83%)", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
    >
        <Stack sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
        }} direction="row" >
            <Typography variant="h1">Loading Cache...</Typography >
            <CircularProgress color="inherit" variant="indeterminate" size={100} />
        </Stack >
    </Backdrop >
    );
}

CacheHydration.displayName = name;

export default CacheHydration;